import "./nordic.ts";
import { recordSubmission } from "./submit.ts";

/** Blog listing: category filter (with empty-state) + subscribe (recorded to D1). */

// ---- category filter ----
const pills = document.querySelectorAll<HTMLElement>(".fpill");
const posts = Array.from(document.querySelectorAll<HTMLElement>("#posts .post"));
const noresult = document.getElementById("noresult");

for (const pill of pills) {
  pill.addEventListener("click", () => {
    for (const x of pills) {
      x.classList.remove("active");
      x.setAttribute("aria-selected", "false");
    }
    pill.classList.add("active");
    pill.setAttribute("aria-selected", "true");

    const cat = pill.dataset.cat ?? "all";
    let shown = 0;
    for (const post of posts) {
      const match = cat === "all" || post.dataset.cat === cat;
      post.classList.toggle("hide", !match);
      if (match) shown++;
    }
    if (noresult) noresult.style.display = shown ? "none" : "block";
  });
}

// ---- subscribe (local only — no backend) ----
const form = document.getElementById("subForm") as HTMLFormElement | null;
const email = document.getElementById("subEmail") as HTMLInputElement | null;
const msg = document.getElementById("subMsg");
if (form && email && msg) {
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
    if (!ok) {
      email.classList.add("err");
      msg.className = "smsg bad";
      msg.textContent = "Please enter a valid email address.";
      email.focus();
      return;
    }
    recordSubmission("newsletter", {
      email: email.value.trim(),
      hp: form.querySelector<HTMLInputElement>('[name="hp"]')?.value ?? "",
    });
    email.classList.remove("err");
    msg.className = "smsg ok";
    msg.textContent = "You're on the list — watch your inbox for the next issue.";
    form.reset();
  });
  email.addEventListener("input", () => email.classList.remove("err"));
}
